import React from 'react';
import { Row, Col, Typography } from 'antd';
import { LuShoppingCart, LuUser } from 'react-icons/lu'
import { VertButton, VertContainer, VertTypography } from '@vertem-core/vertice-ds';
import { formatPrice } from 'Utils/format';
import { useNavigate } from 'react-router';
import { useHierarchyProductsLocalStorageContext } from 'Context/HierarchyLocalStorageContext';
import { useSimulationLocalStorageContext } from 'Context/SimulationLocalSotrageContext';

const SimulationIndicator = () => {
    const navigate = useNavigate()

    const { hierarchyProductsLocalStorageValue, setHierarchyLocalStorageValue } = useHierarchyProductsLocalStorageContext()
    const { simulationLocalStorageValue } = useSimulationLocalStorageContext()

    const watchLocalStorage = () => {
        window.addEventListener("storage", evento => {
            if (evento.key === 'Premmiar@:products') {
                const newValue = JSON.parse(evento.newValue);
                setHierarchyLocalStorageValue({ products: newValue });
            }
            if (evento.key === 'Premmiar@:simulation') {
                const newValue = JSON.parse(evento.newValue);
                setHierarchyLocalStorageValue(newValue);
            }
        });
    }

    watchLocalStorage()

    return (
        <div style={{ backgroundColor: 'var(--color-warning)' }}>
            <VertContainer className='padding-x-regular padding-y-small' >
                <Row gutter={[16, 16]} justify="space-between" align="middle">
                    <Col lg={18} md={18} sm={18} xs={24}>
                        <LuUser color='var(--color-white)' />
                        <VertTypography.Text style={{ color: 'var(--color-white)' }} className='margin-left-extra-small'>
                            Realizando resgate por:
                        </VertTypography.Text>
                        <VertTypography.Text style={{ color: 'var(--color-white)', fontSize: '1.2rem' }} strong className='margin-left-extra-small'>
                            {simulationLocalStorageValue?.name}
                        </VertTypography.Text>
                        <VertTypography.Text style={{ color: 'var(--color-white)' }} className='margin-left-regular'>
                            Saldo:
                        </VertTypography.Text>
                        <VertTypography.Text style={{ color: 'var(--color-white)', fontSize: '1.2rem' }} strong className='margin-left-extra-extra-small'>
                            {formatPrice(simulationLocalStorageValue?.balance).replace('R$', '')} PONTOS
                        </VertTypography.Text>
                    </Col>
                    <Col style={{ display: 'flex', alignItems: 'center' }} lg={6} md={6} sm={6} xs={24}>
                        <div className='padding-x-extra-small padding-y-extra-small' style={{ display: 'flex', alignItems: 'center', borderRadius: 'var(--border-radius-secondary)', backgroundColor: 'var(--color-white)' }}>
                            <LuShoppingCart fontSize={'1.5rem'} color='var(--color-warning)' />
                            <Typography.Text strong style={{ color: 'var(--color-warning)' }} className='margin-left-extra-small'>
                                {hierarchyProductsLocalStorageValue?.products?.length ?? 0}
                            </Typography.Text>
                        </div>
                        <VertButton className='margin-left-small' type="default" onClick={() => navigate('/spot-redemption')}>
                            VOLTAR PARA SIMULAÇÃO
                        </VertButton>
                    </Col>
                </Row>
            </VertContainer>
        </div>
    );
}

export default SimulationIndicator;